import React from "react";

type Props = {};

const SonarQubeReport = (props: Props) => {
  return <div>SonarQubeReport</div>;
};

export default SonarQubeReport;
